import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

/* Utility functions */
Object.byString = function(o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, ''); // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
};

window.escapeHtml = function(string) {
    var pre = document.createElement('pre');
    var text = document.createTextNode(string);
    pre.appendChild(text);
    return pre.innerHTML;
};

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

window.cursorX = window.cursorY = 0;
document.onmousemove = function(e) {
    window.cursorX = e.pageX;
    window.cursorY = e.pageY;
};

window.getCoords = function(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return {
        top: Math.round(top),
        left: Math.round(left)
    };
};

/* Vex (our modal library) */
vex.registerPlugin(VexDialog);
vex.defaultOptions.className = 'vex-theme-wireframe';

/* Promises and HTTP */
if (!window.Promise) window.Promise = require('promise-polyfill');

/* Raven (Sentry) */
if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      environment: process.env.SENTRY_ENVIRONMENT,
      release: process.env.CIRCLE_SHA1,
      integrations: [
        new VueIntegration({Vue, attachProps: true})
      ]
    });
}

/* Miscellaneous */
require('semantic-ui-css/components/transition');
require('semantic-ui-css/components/dimmer');
require('semantic-ui-css/components/modal');

/* Mouseflow */
window._mfq = window._mfq || [];
var mouseflowHtmlDelay = 5000;
var mf = document.createElement('script');
mf.type = 'text/javascript';
mf.async = true;
mf.src = '//cdn.mouseflow.com/projects/7dffd9fe-c04d-42a0-a47f-a3b849487e4a.js';
document.getElementsByTagName('head')[0].appendChild(mf);
/* Mouseflow */

//------------------------ start Pendo ------------------------//
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
      v=['initialize','identify','updateOptions','pageLoad'];for(w=0,x=v.length;w<x;++w)(function(m){
      o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
      y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
      z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('0f9ae8cc-a460-459b-53a3-6a45ceecee9e');
//------------------------ end Pendo ------------------------//

window.toArray = require('./utils/to-array');
